import {useEffect} from 'react'
import {BoardFilters} from '@extensions/sticker/board-filters'
import {useForceUpdate} from './hooks'

export const useBoardFilterUpdateEffect = (callback?: () => void): void => {
  const upd = useForceUpdate()
  useEffect(() => {
    const id = BoardFilters.addListener(() => {
      callback?.()
      upd()
    })
    return () => BoardFilters.removeListener(id)
  }, [])
}
